/**
 * Analytics utility for tracking user events
 * Uses PostHog for analytics (already integrated in index.html)
 */

// Track page views (automatically done by PostHog, but can be manually triggered)
export const trackPageView = (pageName) => {
  if (window.posthog) {
    window.posthog.capture('$pageview', { page: pageName });
  }
};

// Track user signup
export const trackSignup = (source = 'unknown') => {
  if (window.posthog) {
    window.posthog.capture('user_signup', { source });
  }
};

// Track user login
export const trackLogin = () => {
  if (window.posthog) {
    window.posthog.capture('user_login');
  }
};

// Track beta signup
export const trackBetaSignup = (email) => {
  if (window.posthog) {
    window.posthog.capture('beta_signup', { email_domain: email.split('@')[1] });
  }
};

// Track checkout initiated
export const trackCheckoutInitiated = (product, packageId, amount) => {
  if (window.posthog) {
    window.posthog.capture('checkout_initiated', {
      product,
      package_id: packageId,
      amount,
      currency: 'USD'
    });
  }
};

// Track payment success
export const trackPaymentSuccess = (product, packageId, amount) => {
  if (window.posthog) {
    window.posthog.capture('payment_success', {
      product,
      package_id: packageId,
      amount,
      currency: 'USD'
    });
  }
};

// Track feature usage
export const trackFeatureUsage = (feature, details = {}) => {
  if (window.posthog) {
    window.posthog.capture('feature_used', {
      feature,
      ...details
    });
  }
};

// Track CTA clicks
export const trackCTAClick = (ctaName, location) => {
  if (window.posthog) {
    window.posthog.capture('cta_clicked', {
      cta_name: ctaName,
      location
    });
  }
};

// Identify user for personalization
export const identifyUser = (userId, properties = {}) => {
  if (window.posthog) {
    window.posthog.identify(userId, properties);
  }
};

// Reset user (on logout)
export const resetAnalytics = () => {
  if (window.posthog) {
    window.posthog.reset();
  }
};
